import React from 'react';
import Drawer from '../components/Drawer';
import Footer from '../components/Footer';
import PermissionManagerContent from '../components/PermissionManagerContent';

export default function OrganizationPermissionsPage() {
  const pageContent = (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <PermissionManagerContent />
    </div>
  );

  return <><Drawer pageHeader={pageContent} /><Footer /></>;
}
